import { haptic as notify } from "../telegram";
export function haptic(type: "success" | "error" | "warning") {
  try { notify(type); } catch { /* Optional device feedback must never change an operation outcome. */ }
}
